import React from 'react';
import { companyInfo } from '../../data/mockData';

export const ComplianceBar = () => (
  <div className="compliance-bar" data-testid="compliance-footer">
    <strong>{companyInfo.name}</strong> | AMFI-Registered Mutual Fund Distributor |{' '}
    <strong>{companyInfo.arn}</strong>
    <br />
    Disclaimer: Mutual Fund investments are subject to market risks, read all scheme-related
    documents carefully.
  </div>
);
